<template>
    <SentenceData></SentenceData>
</template>

<script>
import SentenceData from '@/components/SentenceData.vue';
export default {
    name: "sentence-data",
    components: { SentenceData }
}
</script>

<style>

</style>